import { labelsApi } from '../api/client';
import { labelExtension } from './labels';

export async function downloadShippingLabel(source: string, format?: string | null, shipmentId = 'shipping', signal?: AbortSignal): Promise<void> {
  const { blob, contentType } = await labelsApi.fetch(source, signal);
  if (signal?.aborted) return;
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${shipmentId.replace(/[^a-z0-9_-]/gi, '_')}-label.${labelExtension(contentType, format)}`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export async function copyTrackingNumber(tracking: string): Promise<void> {
  if (!navigator.clipboard?.writeText) throw new Error('Select the tracking number and copy it manually.');
  await navigator.clipboard.writeText(tracking);
}
